import React from 'react';
import PropTypes from 'prop-types';
import { IonRouterOutlet, IonSplitPane } from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';
import { Menu } from 'containers/layout';
import Loyalty from 'pages/Loyalty';
import LoyaltyDetail from 'pages/LoyaltyDetail';
import BluetoothTestPage from 'pages/BluetoothTest';
import SendLocationPage from 'pages/OrderCart/SendLocationPage';
import Page from './pages/Page';
import Locations from './pages/Locations';
import ViewTab from './pages/ViewTab';
import PayTab from './pages/PayTab';
import PaymentMethods from './pages/PaymentMethods';
import Receipts from './pages/Receipts';
import ReceiptView from './pages/ReceiptView';
import AddPaymentMethod from './pages/AddPaymentMethod';
import ChangePhone from './pages/ChangePhone';
import AccountSettings from './pages/AccountSettings';
import ChangePassword from './pages/ChangePassword';
import TableNumberPage from './pages/TableNumberPage';
import ThankyouPayment from './pages/ThankyouPayment';
import AboutPage from './pages/AboutPage';
import InviteAcceptPage from './pages/InviteAcceptPage';
import MenuItemsPage from './pages/OrderCart/MenuItemsPage';
import MenuItemDetailPage from './pages/OrderCart/MenuItemDetailPage';
import OrderCartPage from './pages/OrderCart/OrderCartPage';
import ViewMenuListPage from './pages/ViewMenu/ViewMenuList';
import ViewMenuItemDetailPage from './pages/ViewMenu/ViewMenuItemDetail';
import LocationTestPage from './pages/LocationTest';
import CardNoticePage from './pages/CardNotice';
import PromotionsPage from './pages/Promotions';
import VenuePromotionsPage from './pages/VenuePromotions';

const UserRoutes = ({ user }) => {
  return (
    <IonSplitPane contentId="main">
      {user.phoneVerified && <Menu />}
      <IonRouterOutlet id="main">
        <Route path="/account-settings" component={AccountSettings} exact />
        <Route path="/loyalty" component={Loyalty} exact />
        <Route path="/loyalty/:programId/detail" component={LoyaltyDetail} exact />
        <Route path="/change-password" component={ChangePassword} exact />
        <Route path="/change-phone" component={ChangePhone} exact />
        <Route path="/locations" component={Locations} exact />
        <Route path="/thankyou" component={ThankyouPayment} exact />
        <Route path="/about" component={AboutPage} exact />
        <Route path="/location-test" component={LocationTestPage} exact />
        <Route path="/bluetooth-test" component={BluetoothTestPage} exact />
        <Route path="/card-notice" component={CardNoticePage} exact />
        <Route path="/promotions" component={PromotionsPage} exact />
        <Route
          path="/promotions/:venueId"
          component={VenuePromotionsPage}
          exact
        />
        <Route
          path="/invite/:venueId/:ticketId"
          component={InviteAcceptPage}
          exact
        />
        <Route
          path="/locations/:locationId/table-number"
          component={TableNumberPage}
          exact
        />
        <Route path="/locations/:locationId/tab" component={ViewTab} exact />
        <Route path="/locations/:locationId/pay" component={PayTab} exact />
        <Route
          path="/locations/:locationId/view-menu"
          component={ViewMenuListPage}
          exact
        />
        <Route
          path="/locations/:locationId/view-menu/:itemId"
          component={ViewMenuItemDetailPage}
          exact
        />
        <Route
          path="/locations/:locationId/cart/add"
          component={MenuItemsPage}
          exact
        />
        <Route
          path="/locations/:locationId/cart/review"
          component={OrderCartPage}
          exact
        />
        <Route
          path="/locations/:locationId/cart/sendLocation"
          component={SendLocationPage}
          exact
        />
        <Route
          path="/locations/:locationId/cart/add/:itemId"
          component={MenuItemDetailPage}
          exact
        />
        <Route path="/payment-methods" component={PaymentMethods} exact />
        <Route path="/receipts" component={Receipts} exact />
        <Route path="/receipts/:receiptId" component={ReceiptView} exact />
        <Route path="/payment-methods/add" component={AddPaymentMethod} exact />
        <Route path="/page/:name" component={Page} exact />
        {user.phoneVerified ? (
          <Route component={() => <Redirect to="/locations" />} />
        ) : (
          <Route component={() => <Redirect to="/verify-code" />} />
        )}
      </IonRouterOutlet>
    </IonSplitPane>
  );
};

UserRoutes.propTypes = {
  user: PropTypes.object,
};

export default UserRoutes;
